class SaveAnswers {
  constructor(
    public questions: {
      questionId: string;
      itemId: string;
    }[] = []
  ) {}
}

class QuizStudent {
  constructor(
    public description: string = "",
    public duration: number = 0,
    public id?: string
  ) {}
}

class StudentQuiz {
  constructor(
    public attempt: number = 0,
    public done: boolean = false,
    public quizTO?: QuizTO
  ) {}
}

class QuizTO {
  constructor(
    public id: string | null = "",
    public courseId: number = 0,
    public description: boolean = false,
    public duration: number = 0,
    public learningObjectiveId: string = "",
    public numberQuestions: string = ""
  ) {}
}

class QuestionStudent {
  constructor(
    public id: string = "",
    public contents: any[] = new Array(),
    public correctItem: any = null,
    public enunciateFile: any = null,
    public items: ItemsStudent[] = [],
    public prompt: string = "",
    public promptType: string = ""
  ) {}
}

class ItemsStudent {
  constructor(
    public id: string = "",
    public answerDescription: any = null,
    public answerFile: any = null,
    public answerText: string = "",
    public answerType: string = ""
  ) {}
}

class QuizResult {
  constructor(
    public id: string = "",
    public current: boolean = false,
    public elapsedTime: number = 0,
    public percentage: number = 0,
    public answerType: string = "",
    public questionAnswers: any[] = [],
    public quiz: QuizStudent = new QuizStudent(),
    public absQuestionAnswers:any[] =[]
  ) {}
}

class QuizResultsHistory {
  constructor(
    public average: number = 0,
    public completedLearningObjectives: number = 0,
    public quiz: QuizRecords = new QuizRecords(),
    public quizRecords: any = {}
  ) {}
}

class QuizRecords {
  constructor(
    public chapterName: string = "",
    public objectiveName: string = "",
    public percentagem: number = 0,
    public status: string = ""
  ) {}
}

class CreateQuiz {
  constructor(
    public id: string = "",
    public courseId?: string,
    public duration?: any,
    public learningObjectiveId?: string,
    public numberQuestions?: number,
    public description: string = ""
  ) {}
}

class Question {
  constructor(
    public id: string = "",
    public contents: any[] = [],
    public correctItem: any = false,
    public correct: any = false,
    public enunciateFile?: any,
    public items: ItemQuestion[] = [],
    public itemTOS: ItemQuestion[] = [],
    public materialReferences: MaterialReferences[] = [],
    public prompt: string = "",
    public answer: string = "",
    public answered: string = "",
    public promptType: "IMAGE" | "TEXT" = "TEXT",
    public openQuestion: boolean = false,
    public type: QuestionType = QuestionType.DEFAULT
  ) {}
}

class QuestionTrueFalse {
  constructor(
    public id: string = "",
    public contents: any[] = [],
    public correctItem: any = false,
    public correct: any = false,
    public enunciateFile?: any,
    public items: ItemQuestionTrueFalse[] = [],
    public itemTOS: ItemQuestion[] = [],
    public materialReferences: MaterialReferences[] = [],
    public prompt: string = "",
    public answer: string = "",
    public answered: string = "",
    public promptType: "IMAGE" | "TEXT" = "TEXT",
    public openQuestion: boolean = false,
    public type: QuestionType = QuestionType.TRUE_OR_FALSE
  ) {}
}
class QuestionDragDrop {
  constructor(
    public id: string = "",
    public contents: any[] = [],
    public enunciateFile?: any,
    public correctItem?: any,
    public items: ItemQuestionDragAndDrop[] = [],
    public itemTOS: ItemQuestionDragAndDrop[] = [],
    public materialReferences: MaterialReferences[] = [],
    public dragAndDropOptions: string[] = [],
    public openQuestion: boolean = false,
    public prompt: string = "",
    public promptType: "IMAGE" | "TEXT" = "TEXT",
    public type: QuestionType = QuestionType.DRAG_AND_DROP
  ) {}
}
class QuestionGap {
  constructor(
    public id: string = "",
    public contents: any[] = [],
    public enunciateFile?: any,
    public correctItem?: any,
    public items: ItemQuestionGap[] = [],
    public itemTOS: ItemQuestionGap[] = [],
    public materialReferences: MaterialReferences[] = [],
    public dragAndDropOptions: string[] = [],
    public openQuestion: boolean = false,
    public prompt: string = "",
    public promptType: "IMAGE" | "TEXT" = "TEXT",
    public type: QuestionType = QuestionType.FILL_IN_THE_BLANKS
  ) {}
}

enum QuestionType {
  DRAG_AND_DROP = "DRAG_AND_DROP",
  FILL_IN_THE_BLANKS = "FILL_IN_THE_BLANKS",
  TRUE_OR_FALSE = "TRUE_OR_FALSE",
  DEFAULT = "DEFAULT",
}
class ItemQuestionTrueFalse {
  constructor(
    public id: string = "",
    public answerType: string = "TEXT",
    public answerDescription?: string,
    public answerText?: string,
    public correctAnswer: boolean = false
  ) {}
}
class ItemQuestion {
  constructor(
    public id: string = "",
    public answerType: string = "",
    public answerDescription?: string,
    public answerText?: string,
    public correct?: boolean,
    public correctAnswer?: boolean,
    public index?: number,
    public items?: any[]
  ) {}
}
class ItemQuestionDragAndDrop {
  constructor(
    public id: string = "",
    public answerText?: string,
    public correctOptions?: string[],
    public correctAnswer?: boolean
  ) {}
}
class ItemQuestionGap {
  constructor(
    public id: string = "",
    public answerText?: string,
    public correctOptions?: string[],
    public correctAnswer?: boolean
  ) {}
}
class ItemQuestionDragNDrop {
  constructor(
    public sentence: string = "",
    public gaps: Array<{ name: string; id: string }> = [],
    public options?: Array<string>
  ) {}
}

class RandomQuestion {
  constructor(
    public id: string = "",
    public learningObjectiveId: string = "",
    public pastLearningObjectiveId?: string,
    public randomQuestion?: Question,
    public userId?: string,
    public wrongQuestion?: Question
  ) {}
}

class MaterialReferences {
  constructor(
    public id: string = "",
    public materialId: string = "",
    public referenceTime: string = "",
    public name: string = ""
  ) {}
}

class QuizData {
  constructor(
    public id: string = "",
    public questionList: Question[] = [],
    public learningObjectiveId: string = ""
  ) {}
}

export {
  CreateQuiz,
  ItemQuestion,
  ItemQuestionTrueFalse,
  QuestionTrueFalse,
  ItemsStudent,
  MaterialReferences,
  Question,
  QuestionStudent,
  QuestionDragDrop,
  QuizData,
  QuizRecords,
  QuizResult,
  QuizResultsHistory,
  QuizStudent,
  SaveAnswers,
  RandomQuestion,
  StudentQuiz,
  QuizTO,
  ItemQuestionDragNDrop,
  QuestionType,
  QuestionGap,
};
